// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import { BrandDetailsCategoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BrandDetailsTitleStyles } from "@store/Library/Widgets/BrandDetails/BrandDetailsTitle";
import { BrandDetailsContentStyles } from "@store/Overrides/Widgets/BrandDetails/BrandDetailsContent";
import { BrandDetailsLogoStyles } from "@store/Overrides/Widgets/BrandDetails/BrandDetailsLogo";
import { useHasLogoOrWebsite } from "@store/Framework/Common/Hooks/Brand";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const BrandTitle = getWidgetComponent("BrandDetails/BrandDetailsTitle");
const BrandLogo = getWidgetComponent("BrandDetails/BrandDetailsLogo");
const BrandImage = getWidgetComponent("BrandDetails/BrandDetailsImage");
const BrandCategories = getWidgetComponent("BrandDetails/BrandDetailsCategories");
const BrandContent = getWidgetComponent("BrandDetails/BrandDetailsContent");

export interface BrandDetailsViewStyles {
    wrapperStyles?: InjectableCss;
    container?: GridContainerProps;
    leftColumnWrapper?: GridItemProps;
    rightColumnWrapper?: GridItemProps;
    brandTitleStyles?: BrandDetailsTitleStyles;
    brandLogoStyles?: BrandDetailsLogoStyles;
    brandCategoriesStyles?: BrandDetailsCategoriesStyles;
    brandContentStyles?: BrandDetailsContentStyles;
}

export const brandDetailsViewStyles: BrandDetailsViewStyles = {
    wrapperStyles: {
        css: css`
            gap: ${pxToRem(24)};
            flex-direction: column;
            margin: ${pxToRem(15)};
        `,
    },
    container: {
        gap: 32,
    },
    leftColumnWrapper: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding-top: ${pxToRem(32)};
            display: block;
        `,
    },
    rightColumnWrapper: {
        css: css`
            ${spacingStyles()}
            flex-direction: column;
        `,
    },
    brandTitleStyles: {
        // VALIDATE WITH PROD
        /*
        container: {
            css: css`
                ${spacingStyles()};
            `,
        },
        */
    },
    brandCategoriesStyles: {
        container: {
            css: css`
                padding-top: 0;
                border-bottom: 1px solid ${getColor("common.border")};

                &:last-child {
                    border-bottom: unset;
                    padding: ${pxToRem(16, 0)};
                }
            `,
        },
    },
    brandContentStyles: {
        container: {
            css: css`
                margin: 0;
            `,
        },
    },
};

const styles = brandDetailsViewStyles;

const BrandDetailsView: FC<WidgetProps> = props => {
    const hasLogoOrWebsite = useHasLogoOrWebsite();

    return (
        <>
            <GridContainer {...styles.wrapperStyles}>
                <GridItem width={12}>
                    <BrandTitle {...styles.brandTitleStyles} {...styles.brandTitleStyles} />
                </GridItem>
                <GridItem width={12}>
                    <GridContainer {...styles.container}>
                        {hasLogoOrWebsite && (
                            <GridItem {...styles.leftColumnWrapper}>
                                <BrandLogo />
                                <Zone contentId={props.id} zoneName="LeftColumn" />
                            </GridItem>
                        )}
                        <GridItem width={hasLogoOrWebsite ? [12, 12, 8, 9, 9] : 12} {...styles.rightColumnWrapper}>
                            <BrandImage />
                            <BrandCategories
                                title={translate("Shop by Category")}
                                gridType="column"
                                showImages={false}
                                subCategoriesToShow={4}
                                {...styles.brandCategoriesStyles}
                            />
                            <BrandContent {...styles.brandContentStyles} />
                            <Zone contentId={props.id} zoneName="RightColumn" />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(BrandDetailsView),
    definition: {
        displayName: "View",
        group: "Brand Details",
        allowedContexts: [BrandDetailsPageContext],
    },
};

export default widgetModule;
